
export const SWIMMING_STYLES = [
    { value: "crawl", label: "Crawl" },
    { value: "backstroke", label: "Costas" },
    { value: "breaststroke", label: "Peito" },
    { value: "butterfly", label: "Borboleta" },
    { value: "medley", label: "Medley" },
    { value: "drills", label: "Educativo" },
    { value: "kicking", label: "Perna" },
    { value: "pulling", label: "Braço" },
];

export const INTENSITIES = [
    { value: "A1", label: "A1 (Leve)" },
    { value: "A2", label: "A2 (Moderado)" },
    { value: "A3", label: "A3 (Forte)" },
    { value: "AN", label: "AN (Anaeróbio)" },
    { value: "VEL", label: "Velocidade" },
];

export const EQUIPMENT = [
    { value: "fins", label: "Pé de Pato" },
    { value: "paddles", label: "Palar" },
    { value: "pullbuoy", label: "Pull Buoy" },
    { value: "snorkel", label: "Snorkel" },
    { value: "board", label: "Prancha" },
    { value: "band", label: "Elástico" },
];

export const DISTANCE_OPTIONS = [
    25, 50, 75, 100, 150, 200, 300, 400, 500, 800, 1000, 1500
];
